module.exports = "<header>\r\n\t<section class=\"content\">\r\n\t\t<h1>Detalles de facturación</h1>\r\n\t</section>\r\n</header>\r\n<viewport ui-view></viewport>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/finanzas/_/detallesFacturacion/template.html
// module id = 2928
// module chunks = 0